import { GarageActionController, type GarageAction } from './garage-action-controller.js';

export interface GarageState {
  readonly selectedMapId: string;
  readonly selectedCarId: string;
}

export type GarageStateAction =
  | { type: 'select-map'; mapId: string }
  | { type: 'select-car'; carId: string }
  | { type: 'restore'; mapId: string; carId: string };

/** Owns garage selection and serialised launch actions behind one state port. */
export class GarageController {
  readonly actions: GarageActionController;
  private stateValue: GarageState;

  constructor(
    initial: GarageState,
    onActionLockChange: (locked: boolean) => void,
  ) {
    this.stateValue = { ...initial };
    this.actions = new GarageActionController(onActionLockChange);
  }

  get state(): GarageState {
    return this.stateValue;
  }

  dispatch(action: GarageStateAction): GarageState {
    switch (action.type) {
      case 'select-map':
        this.stateValue = { ...this.stateValue, selectedMapId: action.mapId };
        break;
      case 'select-car':
        this.stateValue = { ...this.stateValue, selectedCarId: action.carId };
        break;
      case 'restore':
        this.stateValue = { selectedMapId: action.mapId, selectedCarId: action.carId };
        break;
    }
    return this.stateValue;
  }

  begin(action: GarageAction): number {
    return this.actions.begin(action);
  }

  dispose(): void {
    this.actions.cancel();
  }
}

export type { GarageAction };
